<a routerLink="/">
  <figure class="logo {{classCustom}}"> 
    <img [src]="logo" alt="Logo" />
  </figure>
</a> 
  